import { NavItem } from './nav-item/nav-item';

// Converted navCap sections to collapsible dropdown parents 28/10/2026 DW
// activeMatchRoutes keep browse highlight on sibling edit views 28/10/2026 DW
export const navItems: NavItem[] = [
  // Profile browse above Access Control 28/10/2026 DW
  {
    displayName: 'Profile',
    iconName: 'user-circle',
    route: '/profile',
  },
  {
    displayName: 'Access Control',
    iconName: 'lock-access',
    children: [
      {
        displayName: 'Users',
        iconName: 'point',
        route: '/access/users',
        activeMatchRoutes: ['/access/detail', '/access/gidaccesscontrol'],
        // expectedScopes: ['use:access','read:users']
      },
    ],
  },
  {
    displayName: 'Product',
    iconName: 'package',
    children: [
      {
        displayName: 'Product List',
        iconName: 'point',
        route: '/pli/plitable',
        activeMatchRoutes: ['/pli/pliedit'],
      },
      {
        displayName: 'Product Link',
        iconName: 'point',
        route: '/mad/plntable',
        activeMatchRoutes: ['/mad/plnedit'],
      },
    ],
  },
  {
    displayName: 'Auth0',
    iconName: 'key',
    children: [
      {
        displayName: 'Application',
        iconName: 'point',
        route: '/auth0/application',
        activeMatchRoutes: ['/auth0/applicationresource', '/auth0/applicationlog'],
      },
      {
        displayName: 'Resource',
        iconName: 'point',
        route: '/auth0/resource',
      },
    ],
  },
  {
    displayName: 'Auth0 Permissions',
    iconName: 'shield-lock',
    children: [
      {
        displayName: 'Groups',
        iconName: 'point',
        route: '/auth0/groups',
      },
    ],
  },
  {
    displayName: 'Merchant Admin',
    iconName: 'building-store',
    children: [
      {
        displayName: 'Create Merchant Setup',
        iconName: 'point',
        route: '/mad/createmse',
      },
      {
        displayName: 'Merchant Setup',
        iconName: 'point',
        route: '/mad/msetable',
        activeMatchRoutes: ['/mad/mseedit'],
      },
      {
        displayName: 'Service Point Setup',
        iconName: 'point',
        route: '/mad/spstable',
        activeMatchRoutes: ['/mad/spsupdate'],
      },
      {
        displayName: 'Merchant Financial Setup',
        iconName: 'point',
        route: '/mad/mfstable',
        activeMatchRoutes: ['/mad/mfsedit', '/mfs/mfsupdate'],
      },
      // {
      //   displayName: 'Change Origin of Merchant',
      //   iconName: 'point',
      //   route: '/mad/spsorigin',
      //   expectedScopes: ['use:mse_origin']
      // },
      // {
      //   displayName: 'Service Point Info',
      //   iconName: 'point',
      //   route: '/mad/spitable',
      // },
      // {
      //   displayName: 'System Setup',
      //   iconName: 'point',
      //   route: '/mad/ssutable',
      // },
    ],
  },
  {
    // POS-style device icon 28/10/2026 DW
    displayName: 'Device',
    iconName: 'device-tablet-dollar',
    children: [
      {
        displayName: 'Remote Device',
        iconName: 'point',
        route: '/device/remotedevicetable',
        activeMatchRoutes: ['/device/editremotedevice'],
      },
    ],
  },
  {
    displayName: 'Portal',
    iconName: 'world',
    children: [
      {
        displayName: 'Portal Register',
        iconName: 'point',
        route: '/portal/portalregistertable',
        activeMatchRoutes: ['/portal/portalregister'],
      },
    ],
  },
  {
    displayName: 'SMS/Email Functions',
    iconName: 'mail',
    children: [
      {
        displayName: 'Token',
        iconName: 'point',
        route: '/sms/tokentable',
        activeMatchRoutes: ['/sms/edittoken'],
      },
      {
        displayName: 'Template',
        iconName: 'point',
        route: '/sms/templatetable',
        activeMatchRoutes: ['/sms/edittemplate'],
      },
      {
        displayName: 'Event Link',
        iconName: 'point',
        route: '/sms/eventlinktable',
        activeMatchRoutes: ['/sms/editeventlink'],
      },
    ],
  },
  {
    displayName: 'Notice Board',
    iconName: 'clipboard-list',
    children: [
      {
        displayName: 'Notice Board',
        iconName: 'point',
        route: '/noticeboard/noticeboard',
      },
      {
        displayName: 'Notice Board Template',
        iconName: 'point',
        route: '/noticeboard/noticeboardtemplate',
      },
      {
        displayName: 'Notice Board Bank',
        iconName: 'point',
        route: '/noticeboard/noticeboardbanktable',
      },
    ],
  },
  {
    displayName: 'Settings',
    iconName: 'settings',
    children: [
      {
        displayName: 'Global Update',
        iconName: 'point',
        route: '/settings/globalupdate',
      },
    ],
  },
];
